import {isFeatureEnabled} from 'feature-flags';

import {isNilOrEmpty} from 'ramda-adjunct';

import {chatAgentApi} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {featureFlags} from '@dms/feature-flags';

interface UseGetCurrentChatUserProps {
  conversationId?: string;
}

export function useGetCurrentChatUser(props: UseGetCurrentChatUserProps) {
  const {data: currentUser} = useGetCurrentUserInfoQuery();

  const conversationQuery = chatAgentApi.useGetAgentConversationQuery(
    {
      conversationId: props.conversationId || '',
    },
    {
      skip: !isFeatureEnabled(featureFlags.CHAT_FEATURE) || isNilOrEmpty(props.conversationId),
    }
  );

  const currentUserInConversation = conversationQuery.data?.users.find(
    (item) => item.externalUserId === currentUser?.id
  );

  return currentUserInConversation;
}
